'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

type Props = {
  page: number;
  scrollTo?: string;
};

function PaginationLink(props: Props) {
  const { page, scrollTo } = props;

  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);

  params.set('page', page.toString());

  const ariaCurrent = page.toString() === (searchParams.get('page') ?? '1');
  let ariaLabel = `Zu Seite ${page ?? '1'} gehen`;
  if (ariaCurrent) {
    ariaLabel = `Aktuelle Seite, Seite ${page ?? '1'}`;
  }

  return (
    <Link
      href={`?${params.toString()}#${scrollTo}`}
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
      className={clsx('pagination__link', {
        'pagination__link--active': ariaCurrent,
      })}
    >
      {page}
    </Link>
  );
}

export default PaginationLink;
